// Authoritative allowlist for invitee email domains.
// Enforced at: invite creation, invite redemption, login, admin pre-add,
// and the SSO callback handlers. Tricorian sub-company staff (Velenda,
// Cor42) keep their own email domains; they sign in via the Tricorian
// Entra tenant as guests, which keeps the app's single-tenant SSO config
// intact while letting their @velenda.com / @cor42.com identities round-
// trip through the system.
export const ALLOWED_INVITE_DOMAINS = [
  'tricorian.com',
  'velenda.com',
  'cor42.com',
] as const;

export type AllowedDomain = (typeof ALLOWED_INVITE_DOMAINS)[number];

const DOMAIN_RE = new RegExp(
  `^[A-Za-z0-9._%+-]+@(${ALLOWED_INVITE_DOMAINS.map((d) => d.replace(/\./g, '\\.')).join('|')})$`,
  'i',
);

export function isAllowedEmail(email: string): boolean {
  return DOMAIN_RE.test(email.trim());
}
